
import { IOperatorRepositoryDB } from "../../../domains/admin/interfaces/repositories/IOperatorRepositoryDB";
import { Operator } from "../../../domains/admin/aggregates/operator/Operator";
import { IHttpRepository } from "../../interfaces/IHttpRepository";
import LocalForage from 'localforage'
import { HttpRepository } from "../api/_HttpRepository";
import { getGlobalAddLog } from "../appInsights/AppInsights";

const KEY = "@meep/operators"

const addLog = getGlobalAddLog();

export const OperatorRepositoryDB = (
): IOperatorRepositoryDB => {
  const httpRepository: IHttpRepository = HttpRepository()

  const getAll = async (local: string): Promise<Operator[]> => {
    try {
      await sync(local)
      return await LocalForage.getItem<Operator[]>(KEY) ?? [] as Operator[]
    } catch {
      return [] as Operator[]
    }
  };

  const sync = async (local: string): Promise<void> => {
    try {
      const operatorsMeep = await httpRepository.getAsync<Array<any>>(
        `Operador/BuscarOperadoresPorLocalId/${local}`
      );
      const operators = operatorsMeep?.map<Operator>((operatorMeep) => {
        return {
          id: operatorMeep.id,
          name: operatorMeep.nome,
          password: operatorMeep.senha,
          roles: operatorMeep.papeis,
        };
      });

      await LocalForage.setItem(KEY, operators);
    } catch (error) {
      addLog && addLog("GetOperator", error);
    }
  };
  return { getAll };
};
